/**
 * @fileoverview A aparência dos convites da equipe em Usuários (etapa 5 dos
 * planos): o modal de convidar e a lista dos pendentes, nos tons neutros das
 * telas novas, com contraste real no claro, anel de foco de 1px e cor só para
 * o estado (vencido).
 */

import { makeStyles } from "@material-ui/core/styles";

import { dialogShell } from "../../styles/dialogShell";

const useInviteStyles = makeStyles((theme) => {
  const dark = theme.palette.type === "dark";
  const text = dark ? "#FAFAFA" : "#09090B";
  const muted = dark ? "#A1A1AA" : "#52525B";
  const line = dark ? "rgba(255,255,255,0.08)" : "#E4E4E7";
  const card = dark ? "#141416" : "#FFFFFF";
  const bad = dark ? "#FCA5A5" : "#B91C1C";
  const focus = dark ? "rgba(91,124,255,0.6)" : "rgba(61,92,253,0.55)";
  return {
    // O modal de convidar: a moldura compartilhada e o corpo daqui.
    ...dialogShell(theme, { width: 520 }),
    dialogBody: { padding: "18px 22px 4px" },
    footButton: { "&&": { width: "auto", minWidth: 120, padding: "0 18px", marginTop: 0 } },
    // O select na altura dos campos de texto do formulário (o mesmo ajuste da esteira de cadastro).
    select: { marginBottom: 16, "& .MuiOutlinedInput-root": { borderRadius: 10, height: 44, fontSize: 15 } },

    // A lista dos convites que ainda não viraram conta, acima da tabela.
    section: { margin: "0 0 20px" },
    sectionTitle: { margin: "0 0 8px", fontSize: 13, fontWeight: 600, color: muted },
    list: { listStyle: "none", margin: 0, padding: 0, border: `1px solid ${line}`, borderRadius: 12, background: card },
    item: {
      display: "flex", alignItems: "center", gap: 12, padding: "10px 14px", flexWrap: "wrap",
      "& + &": { borderTop: `1px solid ${line}` },
    },
    main: { flex: "1 1 220px", minWidth: 0 },
    email: { fontSize: 14, fontWeight: 600, color: text, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
    meta: { fontSize: 12.5, color: muted, marginTop: 2 },
    expired: { color: bad, fontWeight: 600 },
    actions: { display: "flex", alignItems: "center", gap: 4 },
    action: {
      height: 30, padding: "0 10px", border: "none", borderRadius: 8, background: "transparent", color: text, fontSize: 13, fontWeight: 500,
      fontFamily: "inherit", cursor: "pointer",
      "&:hover": { background: dark ? "rgba(255,255,255,0.06)" : "#F4F4F5" },
      "&:focus-visible": { outline: `1px solid ${focus}`, outlineOffset: 1 },
      "&:disabled": { opacity: 0.45, cursor: "default", background: "transparent" },
    },
    actionDanger: { color: bad },
    headerButton: {
      height: 38, padding: "0 14px", borderRadius: 10, border: `1px solid ${dark ? "rgba(255,255,255,0.14)" : "#D4D4D8"}`,
      background: "transparent", color: text, fontSize: 13, fontWeight: 500, fontFamily: "inherit", cursor: "pointer",
      display: "inline-flex", alignItems: "center", gap: 8,
      "&:hover": { background: dark ? "rgba(255,255,255,0.05)" : "#F4F4F5" },
      "&:focus-visible": { outline: `1px solid ${focus}`, outlineOffset: 1 },
      "&:disabled": { opacity: 0.6, cursor: "not-allowed" },
    },
  };
});

export default useInviteStyles;
